<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-card>
          <v-card-title>
            <h1>{{getString(`Materiale Pubblicitario`)}}</h1>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6 lg4 style="text-align:center;padding:20px">
                <h2 class="q-orange">{{getString('Volantino Scarica App')}}</h2>
                <v-img
                  src="../../../static/img/marketing/POST_SCARICA-APP.png"
                  style="border:solid 3px #d5725b"
                  :lazy-src="`https://picsum.photos/10/6?image=${3 * 5 + 10}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                ></v-img>
                <v-btn
                  @click="download(`POST_SCARICA-APP.png`,0)"
                  class="q-orange-bk q-text-whitesmoke"
                >{{getString(`Scarica`)}}</v-btn>
              </v-flex>
              <v-flex xs12 md6 lg4 style="text-align:center;padding:20px">
                <h2 class="q-orange">{{getString('Adesivo Scarica App')}}</h2>
                <v-img
                  src="../../../static/img/marketing/POST_SCARICA-APP-2.png"
                  style="border:solid 3px #d5725b"
                  contain
                  :lazy-src="`https://picsum.photos/10/6?image=${3 * 5 + 10}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                ></v-img>
                <v-btn
                  @click="download(`POST_SCARICA-APP-2.png`,1)"
                  class="q-orange-bk q-text-whitesmoke"
                >{{getString(`Scarica`)}}</v-btn>
              </v-flex>
              <v-flex xs12 md6 lg4 style="text-align:center;padding:20px">
                <h2 class="q-orange">{{getString('Copertina Facebook')}}</h2>
                <v-img
                  src="../../../static/img/marketing/COPERTINA-APP.png"
                  style="border:solid 3px #d5725b"
                  contain
                  :lazy-src="`https://picsum.photos/10/6?image=${3 * 5 + 10}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                ></v-img>
                <v-btn
                  @click="download(`COPERTINA-APP.png`,2)"
                  class="q-orange-bk q-text-whitesmoke"
                >{{getString(`Scarica`)}}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <a ref="downloadLink" v-show="false"></a>
  </div>
</template>

<script>
import ajax from "../../ajax.js";

export default {
  name: "Marketing",
  mounted: function() {},
  data: () => {
    return {
      catSelected: "Configurazione",
      vidSelected: 0
    };
  },

  methods: {
    download: function(filename, i) {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/shops/download/" + filename, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
          responseType: "arraybuffer"
        })
        .then(response => {
          ajax.validateToken(response.headers, self.$store);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = this.$refs.downloadLink;
          link.href = url;
          link.setAttribute("download", "marketingFile" + i + ".png");
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
          self.loading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}

.border {
  border: 2px solid;
}

.logo-size {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Marketing.vue